import Account from '../../../features/account/Account';
import ContactUs from '../../../features/contactUs/ContactUs';
import Banner from '../../../features/dashboard/banner/Banner';
import CoBranding from '../../../features/dashboard/coBranding/CoBranding';
import Dashboard from '../../../features/dashboard/Dashboard';
import DashBoarDetail from '../../../features/dashboard/dashboarDetail/DashboarDetail';
import Promotion from '../../../features/dashboard/promotion/Promotion';
import TextLink from '../../../features/dashboard/textLink/TextLink';
import Help from '../../../features/helps/Help';
import Home from '../../../features/home/Home';
import Tools from '../../../features/tools/Tools';
import * as constants from '../../../utils/constants/constant';
import PrivateDesktopLayout from '../Layout/Desktop/PrivateDesktopLayout/PrivateDesktopLayout';
import PublicDesktopLayout from '../Layout/Desktop/PublicDesktopLayout/PublicDesktopLayout';
import MobileLoginLayout from '../Layout/Mobile/MobileLoginLayout/MobileLoginLayout';
import PublicMobileLayout from '../Layout/Mobile/PublicMobileLayout/PublicMobileLayout';
import MobileBanner from '../Mobile/MobileDashBoard/MobileBanner/MobileBanner';
import MobileCoBranding from '../Mobile/MobileDashBoard/MobileCoBranding/MobileCoBranding';
import MobileDashBoard from '../Mobile/MobileDashBoard/MobileDashBoard';
import MobilePromotion from '../Mobile/MobileDashBoard/MobilePromotion/MobilePromotion';
import MobileTextLink from '../Mobile/MobileDashBoard/MobileTextLink/MobileTextLink';
import MobileDashboardDetail from '../Mobile/MobileDashboardDetail/MobileDashboardDetail';
import MobileForgot from '../Mobile/MobileForgot/MobileForgot';
import MobileHelp from '../Mobile/MobileHelp/MobileHelp';
import MobileHome from '../Mobile/MobileHome/MobileHome';
import MobileLogin from '../Mobile/MobileLogin/MobileLogin';
import MobileRegister from '../Mobile/MobileRegister/MobileRegister';

const {
  HOME,
  TOOLS,
  HELP_TYPE,
  CONTACT_US,
  MY_ACCOUNT,
  DASHBOARD,
  DASHBOARD_BANNER,
  DASHBOARD_TEXT_LINK,
  DASHBOARD_PROMOTION,
  DASHBOARD_CO_BRANDING,
  INCOME_DETAIL,
  FORGOT,
  LOGIN,
  REGISTER,
} = constants.routes;

export const RouterConfig = [
  {
    path: HOME,
    component: {
      desktop: {
        page: Home,
        layout: PublicDesktopLayout,
      },
      mobile: {
        page: MobileHome,
        layout: PublicMobileLayout,
      },
    },
    needAuthor: false,
    grantPermision: [],
  },
  {
    path: TOOLS,
    component: {
      desktop: {
        page: Tools,
        layout: PublicDesktopLayout,
      },
      mobile: {
        page: Tools,
        layout: PublicMobileLayout,
      },
    },
    needAuthor: false,
    grantPermision: [],
  },
  {
    path: HELP_TYPE,
    component: {
      desktop: {
        page: Help,
        layout: PublicDesktopLayout,
      },
      mobile: {
        page: MobileHelp,
        layout: PublicMobileLayout,
      },
    },
    layout: PublicDesktopLayout,
    needAuthor: false,
    grantPermision: [],
  },
  {
    path: CONTACT_US,
    component: {
      desktop: {
        page: ContactUs,
      },
      mobile: {
        page: ContactUs,
        layout: PublicMobileLayout,
      },
    },
    layout: PublicDesktopLayout,
    needAuthor: false,
    grantPermision: [],
  },
  {
    path: MY_ACCOUNT,
    component: {
      desktop: Account,
      mobile: { page: Account, layout: PublicMobileLayout },
    },
    layout: PublicDesktopLayout,
    needAuthor: true,
    grantPermision: [],
  },
  {
    path: DASHBOARD,
    component: {
      desktop: { page: Dashboard, layout: PublicDesktopLayout },
      mobile: {
        page: MobileDashBoard,
        layout: PublicMobileLayout,
      },
    },
    layout: PublicMobileLayout,
    needAuthor: true,
    grantPermision: [],
  },
  {
    path: DASHBOARD_BANNER,
    component: {
      desktop: { page: Banner, layout: PublicDesktopLayout },
      mobile: {
        page: MobileBanner,
        layout: PublicMobileLayout,
      },
    },
    layout: PrivateDesktopLayout,
    needAuthor: true,
    grantPermision: [],
  },
  {
    path: DASHBOARD_TEXT_LINK,
    component: {
      desktop: { page: TextLink, layout: PublicDesktopLayout },
      mobile: {
        page: MobileTextLink,
        layout: PublicMobileLayout,
      },
    },

    layout: PrivateDesktopLayout,
    needAuthor: true,
    grantPermision: [],
  },
  {
    path: DASHBOARD_PROMOTION,
    component: {
      desktop: { page: Promotion, layout: PublicDesktopLayout },
      mobile: {
        page: MobilePromotion,
        layout: PublicMobileLayout,
      },
    },

    layout: PrivateDesktopLayout,
    needAuthor: true,
    grantPermision: [],
  },
  {
    path: DASHBOARD_CO_BRANDING,

    component: {
      desktop: { page: CoBranding, layout: PublicDesktopLayout },
      mobile: {
        page: MobileCoBranding,
        layout: PublicMobileLayout,
      },
    },
    layout: PrivateDesktopLayout,
    needAuthor: true,
    grantPermision: [],
  },
  {
    path: INCOME_DETAIL,
    component: {
      desktop: { page: DashBoarDetail, layout: PublicDesktopLayout },
      mobile: {
        page: MobileDashboardDetail,
        layout: PublicMobileLayout,
      },
    },

    layout: PrivateDesktopLayout,
    needAuthor: true,
    grantPermision: [],
  },
  {
    path: LOGIN,
    component: {
      desktop: { page: MobileLogin, layout: MobileLoginLayout },
      mobile: {
        page: MobileLogin,
        layout: MobileLoginLayout,
      },
    },

    layout: PrivateDesktopLayout,
    needAuthor: false,
    grantPermision: [],
  },
  {
    path: FORGOT,
    component: {
      desktop: { page: MobileForgot, layout: MobileLoginLayout },
      mobile: {
        page: MobileForgot,
        layout: MobileLoginLayout,
      },
    },

    layout: PrivateDesktopLayout,
    needAuthor: false,
    grantPermision: [],
  },
  {
    path: REGISTER,
    component: {
      desktop: { page: MobileRegister, layout: MobileLoginLayout },
      mobile: {
        page: MobileRegister,
        layout: MobileLoginLayout,
      },
    },

    layout: PrivateDesktopLayout,
    needAuthor: false,
    grantPermision: [],
  },
];
